import React from 'react';
import ReactDOM from 'react-dom';
import NewHomepage from './components/NewHomepage';
import './components/NewHomepage.css';

ReactDOM.render(
  <React.StrictMode>
    <NewHomepage />
  </React.StrictMode>,
  document.getElementById('root')
);
